import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';
import {IReturnAuthorizationPayload} from 'coreClasses/returnAuthorization/IReturnOrderData';

export const endpointsMap: IEndpointsMap = {
	CREATE: {
		path: 'return-authorizations',
		method: 'POST'
	},
	PREVALIDATE: {
		path: 'return-authorizations/pre-validate',
		method: 'POST'
	},
	GET_REASONS: {
		path: 'reasons',
		method: 'GET'
	},
	GET_RETURN_LINK: {
		path: 'return-authorizations/return-link',
		method: 'POST'
	}
};

// Options
export interface ICreateReturnAuthorizationOptions extends IBaseFetchOptions {
	body: IReturnAuthorizationPayload;
}

export interface IPrevalidateOptions extends IBaseFetchOptions {
	body: {
		orderNo: string;
		items: Array<{
			productId: string;
			returnReasonCode?: string;
		}>;
	}
}

export interface IGetReturnAuthorizationReasonsOptions extends IBaseFetchOptions {}

export interface IReturnLinkOptions extends IBaseFetchOptions {
	body: {
		c_orderNo: string;
	}
}

// Response
export interface ICreateReturnAuthorizationResponse extends IBaseResponse {
	redirectUrl: string;
}

export interface IPrevalidateResponse extends IBaseResponse {
	message: string;
}

export interface IReturnAuthorizationReasonsResponse extends IBaseResponse {
	returnReasons: Array< {
		label: string;
		value: string;
	}>;
}

export interface IGetReturnLinkResponse extends IBaseResponse {
	returnLink: string;
}
